const ROUTER = {
  MAIN: '/',
  
  LOGIN: '/login',

  CUSTOMER: '/customer',
  BLOCK: '/customer/block',
  BLOCK_SEARCH: {
    EMAIL: '/customer/block/search/email',
    CNPJ: '/customer/block/search/cnpj'
  },

  FINANCIAL_SEARCH: {
    EMAIL: '/financial/search/email',
    CNPJ: '/financial/search/cnpj'
  },
  FINANCIAL: '/financial',
  BILLING: '/financial/billing',
  FINANCIAL_CONFIG: '/financial/config',

  PLANS: '/plans',
  CUSTOMER_PLAN_TABLE: {
    SEARCH: '/plans/search',
    SEARCH_EMAIL: '/plans/search/email',
    SEARCH_CNPJ: '/plans/search/cnpj'
  },

  FILTERS: '/filters',
  FILTERS_MANAGE: '/filters/manage',
  FILTERS_LIST: '/filters/list',
  
  PRODUCTS: '/products',
  CUSTOMER_PRODUCT_TABLE: {
    SEARCH: '/products/search',
    SEARCH_EMAIL: '/products/search/email',
    SEARCH_CNPJ: '/products/search/cnpj'
  },

  NOTIFICATIONS: '/notifications',

  LOG: '/managerLog'
}

export default ROUTER